// Auto-generated skeleton for ReadBy

import { User } from "./User";

export const ReadBy: Api.ReadBy = {
  id: 0,
  user_id: 0,
  user: User,
  created: null,
  updated: null,
};

